import type { StoreAssistant } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { getInteractionModeExecutedFromStreamResponse } from './getInteractionModeExecutedFromStreamResponse';

export const getInteractionModeExecutedFromStoreAssistant = (
	storeAssistant?: Pick<StoreAssistant, 'content'> | null,
): string | undefined => getInteractionModeExecutedFromStreamResponse(storeAssistant?.content);
